import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";

export const CheckboxContainer = styled.div`
  ${({ hasMarginBottom }) =>
    hasMarginBottom &&
    css`
      margin-bottom: 24px;
    `}
`;

export const LabelText = styled.div`
  margin-left: 8px;
`;

export const LabelContainer = styled.label`
  display: flex;
  align-items: center;
`;

export const InputBox = styled.input`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const InputVisual = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 2px rgba(17, 43, 68, 0.15);
  ${({ isChecked }) =>
    `background-color: ${
      isChecked ? buildColor("blue_accent", "500") : buildColor("white", "100")
    }`};
  ${({ isChecked }) =>
    isChecked ? "" : `border: 1px solid ${buildColor("blue", "200")}`};

  > svg {
    position: absolute;
  }

  ${({ isRadio }) =>
    isRadio &&
    css`
      border-radius: 50%;
    `};
`;
